import config from '@/config/index';

/**
 * 增加视频
 *
 * @param title            标题
 * @param orgid            所属机构
 * @param uploadUid        上传者
 * @param industryCategory 分类
 * @param tags             标签
 * @param profile          简介
 * @param contacts         联系人
 * @param mobile           手机号
 * @param cover            封面
 * @param uri              视频地址
 * @param isRedirect       是否跳转
 * @param redirectUri      跳转地址
 * @param show             是否显示
 * @param request
 * @return
 */
function addVideo() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/video`;
}

function modifyVideo() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/modifyvideo`;
}

/**
 * @param id
 * @param request
 * @return
 */
function deleteVideo() {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/deletevideo`;
}

/**
 * @param id ID
 * @return
 */
function getVideoById(id) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/video/${id}`;
}

/**
 * @param orgid 机构ID
 * @return
 */
function getVideosByOrgid(orgid) {
  return `${config.HOST_API}${config.BASE_API_PREFIX}/videosbyorgid/${orgid}`;
}

/**
 * 获取视频列表（网站前端用）
 * 获取所有审核过的视频
 * 获取审核过的视频
 * page  第几页
 * limit 限制多少航
 * @param request
 * @return@GetMapping("/searchvideo")
 */
function searchVideos() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchvideo`;
}

/**
 * 获取系统后台上传的视频列表（网站前端用）
 * 获取所有审核过的视频
 * page  第几页
 * limit 限制多少航
 *
 * @param request
 * @return @GetMapping("/searchplatformvideo")
 */
function searchPlatFormVideos() {
  return `${config.HOST_API}${config.OP_API_PREFIX}/searchplatformvideo`;
}

/**
 * 获取平台视频详情
 *
 * @param vid
 * @param request
 * @return
 */
function getPlatformVideo(vid) {
  return `${config.HOST_API}${BASE_API_PREFIX}/platformvideo/${vid}`;
}

export {
  addVideo,
  modifyVideo,
  deleteVideo,
  getVideoById,
  getVideosByOrgid,
  searchVideos,
  searchPlatFormVideos,
  getPlatformVideo
};
